module.exports = __webpack_public_path__ + "img/hkia-5.e399bed6.jpg";